module.exports = __webpack_public_path__ + "img/star_min.85dd78c1.png";